// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectInstrumentUpdateMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_TRADE_INSTRUMENT);
        this.Name = null;
        this.InstrumentID = null;
        this.ContractID = null;
        this.TradeSessionStatusId = null;
        this.ExchangeSessionName = null;
    }
}
